import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class DialogWrapperEventService {
  public readonly validateAndSave = new EventEmitter<void>();
}
